import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';
import { RootState } from '../../store';
import { removeSnackbar, SnackbarNotification } from '../../store/slices/notificationSlice';

const SnackbarManager: React.FC = () => {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state: RootState) => state.notification);

  const handleClose = (id: string) => {
    dispatch(removeSnackbar(id));
  };

  return (
    <>
      {notifications.map((notification: SnackbarNotification) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={notification.autoHideDuration || 6000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={() => handleClose(notification.id)}
        >
          <Alert
            onClose={() => handleClose(notification.id)}
            severity={notification.severity}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default SnackbarManager; 